export const baseSelectedFilterOptionChipTailwindStyles = 'flex items-center rounded-full px-3 py-1 gap-3 font-main text-navy-90 text-lg font-normal border-navy-50 border';
